import { render } from "./BanDieuHanh.vue?vue&type=template&id=0df0cb05"
import script from "./BanDieuHanh.vue?vue&type=script&lang=js"
export * from "./BanDieuHanh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__